import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../../shared/services/auth.service';
import { RolesEnum } from '../../shared/utils/routes';

export const revenueManagerGuard: CanActivateFn = ( route, state ) => {
  const getRoles = inject( AuthService ).getRoles();
  const checkRole = getRoles.includes( RolesEnum.AdminRole ) || getRoles.includes( RolesEnum.ViewerRole ) || getRoles.includes(
    RolesEnum.EditorRole );

  if( checkRole ) {
    return true;
  }
  else {
    inject( Router ).navigateByUrl( inject( AuthService ).routeEnabledModule() );
    return false;
  }
}
